import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import ActionButton from '@/common/components/buttons/ActionButton';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import SerpMonitoringAlertsTable from './components/alertsTable/SerpMonitoringAlertsTable';
import SerpMonitoringMainTable from './components/mainTable/SerpMonitoringMainTable';
import SerpMonitoringReportSearchBox from './components/searchBox/SerpMonitoringReportSearchBox';
import useSerpMonitoringReport from './hooks/useSerpMonitoringReport';
import { ConfirmActions } from './SerpMonitoringReport.styles';

const SerpMonitoringReport = () => {
	const {
		report,
		isLoading,
		pendingCategory,
		setPendingCategory,
		fetchReport,
		confirmCategoryChange,
		buildXlsx,
	} = useSerpMonitoringReport();

	return (
		<>
			{isLoading && <Loading />}
			<WrapperWithScroll>
				<SerpMonitoringReportSearchBox
					onSearch={fetchReport}
					onBuildXlsx={buildXlsx}
					isLoading={isLoading}
				/>
				{report && (
					<>
						<SerpMonitoringMainTable
							mainResults={report.mainResults}
							dayResults={report.dayResults}
							onCategoryChange={setPendingCategory}
						/>
						<SerpMonitoringAlertsTable alertResults={report.alertResults} />
					</>
				)}
			</WrapperWithScroll>
			{pendingCategory && (
				<PopUp setShow={() => setPendingCategory(null)}>
					<p>
						Change category to <b>{pendingCategory.category}</b>?
					</p>
					<ConfirmActions>
						<ActionButton
							text='Cancel'
							onClick={() => setPendingCategory(null)}
						/>
						<ActionButton text='Confirm' onClick={confirmCategoryChange} />
					</ConfirmActions>
				</PopUp>
			)}
		</>
	);
};

export default SerpMonitoringReport;
